 // let wsurl = 'ws://localhost:8899/connectWebSocket/' // 本地
  let wsurl = 'ws://192.168.10.91:8899/connectWebSocket/'  //代理服务器
// let wsurl = 'wss://zhjgg.cn:8899/connectWebSocket/'  //代理服务器

let ws = null
let weboscket_callback = null

let wsHandler={
// //获取 websocket 推送的数据
 websocketonmessage:function (e)  {
    return e
},



// 连接成功
 websocketonopen:function (e)  {
    console.log('连接 websocket 成功')
},

// 连接失败时重新连接
 websocketonerror:function ()  {
    this.initWebSocket()
},



// 断开链接后报错
websocketclose:function (e) {
    console.log('断开连接', e)
},



// 手动关闭 websocket
 closewebsocket:function () {
    ws.close()
},

    initWebSocket :function (userId) {
    //初始化 websocket
    ws = new WebSocket(wsurl+userId)
    // ws.onmessage = this.websocketonmessage()
    // ws.onopen = this.websocketonopen()
    // ws.onerror = this.websocketonerror()
    // ws.onclose = this.websocketclose()
    return ws
},



// 发送数据
sendData:function (data, userId)  {
    //  判断 data 数据类型
    if (typeof data != 'string') {
        data = JSON.stringify(data)
    }

    //  判断 websocket 的状态
    if (ws.readyState === ws.OPEN) {
        // 已经打开,可以直接发送
        ws.send(data)
    } else if (ws.readyState === ws.CONNECTING) {
        // 正在开启状态中,则 1 秒后重新发送
        setTimeout(() => {
            ws.send(data)
        }, 1000)
    } else {
        // 未打开，则开启后重新调用
        this.initWebSocket(userId)
        this.sendData(data, userId)
    }
},
}



// 导出
export  { wsHandler}
